import React, { useMemo } from 'react';

const RangeSpan = ({
  min,
  max,
  minimumDifference,
  x,
  width,
  absoluteMax,
  absoluteMin,
}) => {
  // Make sure the bar is at least as tall as the minimum difference
  const { calculatedMin, calculatedMax } = useMemo(() => {
    if (max - min < minimumDifference) {
      const differencePad = (minimumDifference - (max - min)) / 2;

      return {
        calculatedMin: Math.max(absoluteMin, min - differencePad),
        calculatedMax: Math.min(absoluteMax, max + differencePad),
      };
    }
    return {
      calculatedMin: Math.max(absoluteMin, min),
      calculatedMax: Math.min(absoluteMax, max),
    };
  }, [min, max, minimumDifference, absoluteMax, absoluteMin]);

  return (
    <rect
      x={x}
      y={calculatedMin}
      width={width}
      height={calculatedMax - calculatedMin}
      rx={width / 2}
      className="palette-fill range-span"
    />
  );
};

export default RangeSpan;
